import constate from 'constate'
import { useParams } from 'react-router'
import { useGetEmployeeProfileQuery } from '@/features/employee-data/employee-data.api.ts'
import { useCallback } from 'react'
import { useAuth } from '@/common/hooks/useAuth.ts'

export const [EmployeeProfileProvider, useEmployeeProfileContext] = constate(() => {
  const { employeeId } = useParams() as { employeeId: string }
  const { userProfile } = useAuth()

  const { data, isFetching, isLoading, error } = useGetEmployeeProfileQuery({ employeeId })
  const employee = data?.employee
  const isSelfViewing = !!employee && !!userProfile && employee.employeeId === userProfile.employeeId

  const hasSectionAccess = useCallback((section: string) => {
    return !!data?.accessibleSections.includes(section)
  }, [data])

  // Profile view is read-only — no write access
  const hasWriteAccess = useCallback((_section: string) => false, [])

  return {
    isSelfViewing,
    employeeId,
    isFetching,
    isLoading,
    error,
    employee,
    viewRole: data?.viewRole,
    accessibleSections: data?.accessibleSections || [],
    hasSectionAccess,
    hasWriteAccess,
  }
})
